import { useSearchParams } from 'next/navigation';
import Button from '@/components/molecules/button/button';
import Container from '@/components/utilities/container/container';
import styles from './onboarding-flow-finish-step-form-module.module.scss';

export type OnboardingFlowFinishStepFormModuleProps = Omit<
  Content.Components['OnboardingFlowFinishStepFormModuleDto'],
  '$type' | 'id' | 'pageId' | 'settings'
>;

const OnboardingFlowFinishStepFormModule = ({
  link,
}: OnboardingFlowFinishStepFormModuleProps) => {
  const searchParams = useSearchParams();

  const returnTo = searchParams!.get('returnTo');

  return (
    <div className={styles.component}>
      <Container className={styles.container}>
        <Button
          target={link?.target}
          text={link?.text}
          url={returnTo || link?.url}
        />
      </Container>
    </div>
  );
};

OnboardingFlowFinishStepFormModule.displayName =
  'OnboardingFlowFinishStepFormModule';

export default OnboardingFlowFinishStepFormModule;
